function notImplemented(): unknown {
  throw new Error('Not implemented');
}

function noop() {
  // Empty
}

export { notImplemented, noop };
